import { NavLink } from 'react-router'
import './Sidebar.css'

interface NavItem {
  to: string
  label: string
  icon: string
  badge?: number
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Fleet overview', icon: '\u25EB' },
  { to: '/detections', label: 'Detections', icon: '\u25C8' },
  { to: '/devices', label: 'Devices', icon: '\u25A3' },
  { to: '/rules', label: 'Rules', icon: '\u29C9' },
  { to: '/settings', label: 'Settings', icon: '\u2699' },
]

interface SidebarProps {
  detectionBadgeCount?: number | undefined
  rulesVersion?: string | undefined
  lastRulePush?: string | undefined
}

export function Sidebar({ detectionBadgeCount = 0, rulesVersion, lastRulePush }: SidebarProps) {
  return (
    <nav className="sidebar" aria-label="Main navigation">
      <div className="sidebar__brand">
        <div className="sidebar__brand-row">
          <span className="sidebar__brand-name">DEAD CHANNEL</span>
          <span className="sidebar__brand-ice">ICE</span>
        </div>
        <div className="sidebar__brand-sub">THE SPRAWL</div>
      </div>

      <ul className="sidebar__nav">
        {NAV_ITEMS.map((item) => {
          const badge = item.to === '/detections' ? detectionBadgeCount : undefined
          return (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `sidebar__nav-item ${isActive ? 'sidebar__nav-item--active' : ''}`
                }
              >
                <span className="sidebar__nav-icon">{item.icon}</span>
                <span className="sidebar__nav-label">{item.label}</span>
                {badge !== undefined && badge > 0 ? (
                  <span className="sidebar__badge">{badge}</span>
                ) : null}
              </NavLink>
            </li>
          )
        })}
      </ul>

      <div className="sidebar__footer">
        {rulesVersion ? <div className="sidebar__footer-line">Rules: {rulesVersion}</div> : null}
        {lastRulePush ? <div className="sidebar__footer-line">Updated: {lastRulePush}</div> : null}
      </div>
    </nav>
  )
}
